import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=2588708a"
import script from "./Layouts.vue?vue&type=script&lang=js"
export * from "./Layouts.vue?vue&type=script&lang=js"
import style0 from "./Layouts.vue?vue&type=style&index=0&id=2588708a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports